export default __webpack_public_path__ + "static/media/title.59a6d03e.png";